import moment from "moment";
import { formatCurrency } from "../Billing/billingOverview.utils";
import {
  formatBillingStateLabel,
  getBillingStateVariant,
} from "./tenantBilling.utils";

export const formatBillingExpiryHint = (billing = {}) => {
  if (billing.on_trial && billing.trial_end_date) {
    const trialEnd = moment(billing.trial_end_date);
    if (trialEnd.isValid()) {
      return `Trial ends ${trialEnd.format("D MMM YYYY")}`;
    }
  }

  if (billing.next_payment_attempt) {
    const nextAttempt = moment(billing.next_payment_attempt);
    if (nextAttempt.isValid()) {
      return `Next attempt ${nextAttempt.format("D MMM YYYY")}`;
    }
  }

  return null;
};

export const formatOutstandingShort = (billing = {}) => {
  if ((billing.outstanding_cents || 0) > 0) {
    return formatCurrency(billing.outstanding_cents, billing.currency || "AUD");
  }

  if ((billing.open_invoice_count || 0) > 0) {
    const count = billing.open_invoice_count;
    return `${count} open invoice${count === 1 ? "" : "s"}`;
  }

  return null;
};

export const hasBillingAttention = (billing = {}) =>
  billing.billing_state === "payment_failed" ||
  (billing.outstanding_cents || 0) > 0 ||
  (billing.on_trial &&
    billing.trial_end_date &&
    moment(billing.trial_end_date).isBefore(moment().add(14, "days")));

export const buildTenantListBillingCell = (row = {}) => {
  const billing = row.billing || {};

  return {
    planName: billing.plan_name || row.plan_name || "—",
    stateLabel: formatBillingStateLabel(billing.billing_state),
    stateVariant: getBillingStateVariant(billing.billing_state),
    expiryHint: formatBillingExpiryHint(billing),
    outstanding: formatOutstandingShort(billing),
    subscriptionStatus: billing.subscription_status,
    isPaying: billing.is_paying,
  };
};
